module.exports = __webpack_public_path__ + "static/media/Alerta2.d3fe8445.jpeg";